import React, { useContext, useEffect } from 'react'
import * as cam from "@mediapipe/camera_utils"
// import { pMediapipeOptions, pStatus } from "../utils/parameters";
//import { Holistic, POSE_CONNECTIONS, FACEMESH_TESSELATION, HAND_CONNECTIONS } from '@mediapipe/holistic/holistic';
import { Hands, HAND_CONNECTIONS  } from '@mediapipe/hands/hands';
import { Pose, POSE_CONNECTIONS } from '@mediapipe/pose/pose';
import {drawConnectors, drawLandmarks } from '@mediapipe/drawing_utils/drawing_utils';
import { useSnackbar } from 'notistack';
import { pMediapipeHandDetected } from "../utils/parameters";


const HandsPoseDonateContext = React.createContext();

export function useHandsPoseDonate() {
    return useContext(HandsPoseDonateContext)
}

export function MediapipeHandsPoseDonate({ children }) {

    const { enqueueSnackbar } = useSnackbar();

    let hands = null;
    let pose = null;
    let camera = null;
    let counter_fps_hands = 0
    let counter_fps_pose = 0
    let hand_detected = pMediapipeHandDetected.BOTH

    // const idx_kps_pose_right_hand = [16, 18, 20, 22];
    // const idx_kps_pose_left_hand = [15, 17, 19, 21];

    const idx_kp_pose_right_hand = 16
    const idx_kp_pose_left_hand = 15

    const idx_kp_pose_right_shoulder = 12
    const idx_kp_pose_left_shoulder = 11

    const width_input = 640;
    const height_input = 480;

    // const width_input = 640;
    // const height_input = 640;


    useEffect(() => {
        console.log('CONTEXT OF Mediapipe')
    }, [])

    function start_Mediapipe(video) {
        console.log('start_Mediapipe')
        load_model_Pose()
        // load_model_Hands()
        load_camera(video);
    }

    async function load_model_Pose() {
        if (pose==null){
            console.log('Load pose model');
            pose = new Pose({locateFile: (file) => {return `https://cdn.jsdelivr.net/npm/@mediapipe/pose/${file}`;}});
            // await pose.initialize(); // Add this line to initialize the model before setting options and callbacks

            // pose = new Pose({locateFile: (file) => {return `assets/mediapipe/pose/${file}`;}});
            pose.onResults(onResultsPose);

            pose.setOptions({
                modelComplexity: 1,
                smoothLandmarks: false,
                minDetectionConfidence: 0.5,
                minTrackingConfidence: 0.5
            });
            
            
        }else{
            console.log('Pose model already implemeted')
        }
    }
    
    function load_model_Hands() {
        if (hands==null){
            console.log('Load hands model');
            hands = new Hands({locateFile: (file) => {return `https://cdn.jsdelivr.net/npm/@mediapipe/hands/${file}`;}});
            hands.onResults(onResultsHands);
            hands.setOptions({
                maxNumHands: 0,
                minDetectionConfidence: 0.5,
                minTrackingConfidence: 0.5
            });
            enqueueSnackbar('Mediapipe model loaded.', { variant: 'success', });
        }else{
            console.log('Hands model already implemeted')
        }
    }

    function onResultsPose(results) {
        
        if (pose!==null) {
            if (results.poseLandmarks !== undefined) {
                // const kps_hand_left = new Array(4).fill([0,0,0,0]);
                // const kps_hand_right = new Array(4).fill([0,0,0,0]);

                // for (const [idx, idx_mediapipe] of idx_kps_pose_left_hand.entries()) {
                //     kps_hand_left[idx] = [results.poseLandmarks[idx_mediapipe].x, results.poseLandmarks[idx_mediapipe].y, results.poseLandmarks[idx_mediapipe].z, results.poseLandmarks[idx_mediapipe].visibility];
                // }
                // for (const [idx, idx_mediapipe] of idx_kps_pose_right_hand.entries()) {
                //     kps_hand_right[idx] = [results.poseLandmarks[idx_mediapipe].x, results.poseLandmarks[idx_mediapipe].y, results.poseLandmarks[idx_mediapipe].z, results.poseLandmarks[idx_mediapipe].visibility];
                // }

                // const [mean_x_left, mean_y_left, mean_z_left, mean_v_left] = kps_hand_left.reduce(
                //     (accumulator, currentValue) => {
                //       return [      accumulator[0] + currentValue[0],
                //         accumulator[1] + currentValue[1],
                //         accumulator[2] + currentValue[2],
                //         accumulator[3] + currentValue[3]
                //       ];
                //     }, [0, 0, 0, 0]).map((sum) => sum / kps_hand_left.length);
                
                // const [mean_x_right, mean_y_right, mean_z_right, mean_v_right] = kps_hand_right.reduce(
                //     (accumulator, currentValue) => {
                //       return [      accumulator[0] + currentValue[0],
                //         accumulator[1] + currentValue[1],
                //         accumulator[2] + currentValue[2],
                //         accumulator[3] + currentValue[3]
                //       ];
                //     }, [0, 0, 0, 0]).map((sum) => sum / kps_hand_right.length);
                const data_hands = {
                    left: {
                        x : results.poseLandmarks[idx_kp_pose_left_hand].x,
                        y : results.poseLandmarks[idx_kp_pose_left_hand].y,
                        z : results.poseLandmarks[idx_kp_pose_left_hand].z,
                        v : results.poseLandmarks[idx_kp_pose_left_hand].visibility,
                    },
                    right: {
                        x : results.poseLandmarks[idx_kp_pose_right_hand].x,
                        y : results.poseLandmarks[idx_kp_pose_right_hand].y,
                        z : results.poseLandmarks[idx_kp_pose_right_hand].z,
                        v : results.poseLandmarks[idx_kp_pose_right_hand].visibility,
                    }
                };

                const data_shoulder = {
                    left: {
                        x : results.poseLandmarks[idx_kp_pose_left_shoulder].x,
                        y : results.poseLandmarks[idx_kp_pose_left_shoulder].y,
                        z : results.poseLandmarks[idx_kp_pose_left_shoulder].z,
                        v : results.poseLandmarks[idx_kp_pose_left_shoulder].visibility,
                    },
                    right: {
                        x : results.poseLandmarks[idx_kp_pose_right_shoulder].x,
                        y : results.poseLandmarks[idx_kp_pose_right_shoulder].y,
                        z : results.poseLandmarks[idx_kp_pose_right_shoulder].z,
                        v : results.poseLandmarks[idx_kp_pose_right_shoulder].visibility,
                    }
                }


                const threshold = 0.7;
                const leftHandVisible = data_hands.left.v > threshold;
                const rightHandVisible = data_hands.right.v > threshold;

                const leftShoulderVisible = data_shoulder.left.v > threshold;
                const rightShoulderVisible = data_shoulder.right.v > threshold;

                const leftHandShoulder = (leftHandVisible && leftShoulderVisible) ? data_hands.left.y < data_shoulder.left.y : false
                const rightHandShoulder = (rightHandVisible && rightShoulderVisible) ? data_hands.right.y < data_shoulder.right.y : false
                

                const show = true
                // if (show) console.log('leftHandVisible', leftHandVisible)
                // if (show) console.log('rightHandVisible', rightHandVisible)

                // if (show) console.log('leftShoulderVisible', leftShoulderVisible)
                // if (show) console.log('rightShoulderVisible', rightShoulderVisible)

                // if (show) console.log('leftHandShoulder', leftHandShoulder)
                // if (show) console.log('leftHandShoulder', rightHandShoulder)
                
                // if (show) console.log('data_hands: ', data_hands);
                // if (show) console.log('data_shoulder: ', data_shoulder);

                if (leftHandShoulder || rightHandShoulder){
                    if (leftHandShoulder && !rightHandShoulder){
                        hand_detected = pMediapipeHandDetected.LEFT
                        if (show) console.log('MANO IZQUIERDA LEVANTADA');
                    }else if (rightHandShoulder && !leftHandShoulder){
                        hand_detected = pMediapipeHandDetected.RIGHT
                        if (show) console.log('MANO DERECHA LEVANTADA');
                    }else{
                        hand_detected = pMediapipeHandDetected.BOTH
                        if (show) console.log('AMBAS MANOS LEVANTADAS');
                    }
                }else{
                    hand_detected = pMediapipeHandDetected.NONE
                    if (show) console.log('NINGUNA MANO LEVANTADA');
                }
            }
        }
    }

    function onResultsHands(results) {
        console.log('ResultHands: ' +results)
    }

    function mediapipe_getFPS(clear = false){
        //console.log('FPS. Hands: '+counter_fps_hands+' Pose: '+counter_fps_pose)
        const out = [counter_fps_hands, counter_fps_pose]
        if (clear === true){
            counter_fps_hands = 0
            counter_fps_pose = 0
        }
        return out
    }

    function load_camera(video){
        if (camera === null){
            camera = new cam.Camera(video, { width: {width_input}, height: {height_input},
                onFrame: async () => { 
                        await pose.send({ image: video });
                        // await hands.send({ image: video });
                    }
                });
            camera.start()
        }else {
            console.log('camera yet started')
        }
    }

    function stop_Mediapipe() {
        console.log('stop_Mediapipe')
        camera = null;
        pose = null;
    }

    function out_hand_detected(){
        return hand_detected
    }

    const value = {
        start_Mediapipe, stop_Mediapipe, mediapipe_getFPS, out_hand_detected
    }

    return (
        <HandsPoseDonateContext.Provider value={value}>
            {children}
        </HandsPoseDonateContext.Provider>
    )

}